import {Navigate, Route, Routes} from 'react-router-dom';
import {UserLayout} from '@tinct/web-layout';
import {User} from '@tinct/core-api-models';
import {useConnectedUser} from "@tinct/core-store-session";
import {useWorkspaceSettingsNavigation} from "../hooks/use-workspace-settings-navigation";
import {AccountRoutes} from "@tinct/web-feature-users";
import {SnippetRoutes, TeamsRoutes, SecurityRoutes, IntegrationsRoutes, ServiceAccountsRoutes, DomainHostingRoutes} from "@tinct/web-feature-organizations";
import {BillingRoutes, CheckoutSucceedModal, PastDueInvoiceBanner, PaywallProRequiredModal} from "@tinct/web-feature-payment";
import {useUserNavigation} from "../hooks/use-user-navigation";
import {BrandSettingsRoutes} from "@tinct/web-feature-brand";
import {useIsAgencyWorkspace} from "@tinct/core-workspace";
import {useConfig} from "@tinct/core-config";

export const WorkspaceSettingsRoutes = ({
  baseWorkspaceUrl,
}: {
  baseWorkspaceUrl: string;
  }) => {

  const connectedUser = useConnectedUser() as User;
  // Agencies only manage members: brand, snippet, integrations and service
  // accounts are content abilities they do not have.
  const isAgency = useIsAgencyWorkspace();
  const {isFeatureEnabled} = useConfig();
  const landingPageGenerationEnabled = isFeatureEnabled('landingPageGeneration');
  const workspaceSettingsNavigation =
    useWorkspaceSettingsNavigation(baseWorkspaceUrl, isAgency);


  const settingsBaseUrl = `${baseWorkspaceUrl}/settings`;
  const userNavigation = useUserNavigation(`${baseWorkspaceUrl}`, '/settings');

  return (
    <Routes>
      <Route
        element={
          <div>
            <UserLayout
              banner={<PastDueInvoiceBanner />}
              backLink={`${baseWorkspaceUrl}/${isAgency ? 'agency' : 'dashboard'}`}
              connectedUser={connectedUser}
              navUserItems={userNavigation}
              mainNavigationGroups={[
                { sectionName: 'Settings', items: workspaceSettingsNavigation },
              ]}
              version={__APP_VERSION__}
            />
            <PaywallProRequiredModal />
            <CheckoutSucceedModal />
          </div>
        }
      >
        {!isAgency && (
          <>
            <Route path="brand-guidelines/*" element={<BrandSettingsRoutes />} />
            <Route path="snippet" element={<SnippetRoutes />} />
            {landingPageGenerationEnabled && (
              <Route path="domain-hosting" element={<DomainHostingRoutes />} />
            )}
            <Route path="service-accounts" element={<ServiceAccountsRoutes />} />
            <Route path="integrations/*" element={<IntegrationsRoutes />} />
          </>
        )}
        <Route path="teams" element={<TeamsRoutes />} />
        <Route path="security" element={<SecurityRoutes />} />
        <Route path="billing/*" element={<BillingRoutes />} />
        <Route path="account/*" element={<AccountRoutes baseUrl={`${baseWorkspaceUrl}/settings`}/>} />
        <Route path="*" element={<Navigate to={`${settingsBaseUrl}/${isAgency ? 'teams' : 'brand-guidelines'}`} replace />} />
      </Route>
    </Routes>
  );
};
